import _defineProperty from "/home/vsts/work/r1/a/artifacts/source-code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable @typescript-eslint/no-magic-numbers */
const FLAG_SIZE = {
  width: 177,
  height: 179
};
const FLAG_PATH_PREFIX = 'img/asset/flags/';
const FLAG_CODES = ['AD', 'AR', 'BE', 'BG', 'BP', 'CS', 'DE', 'EN', 'ES', 'FI', 'FR', 'GD', 'GL', 'GR', 'HU', 'IS', 'IT', 'JA', 'KO', 'LT', 'NL', 'NO', 'PL', 'PT', 'RO', 'RU', 'SE', 'SH', 'ZH', 'BSL'];
const SIZES_SPLASH_SCREEN = [[750, 1294], [640, 1136], [2732, 2048], [2436, 1125], [2224, 1668], [2148, 1242], [2048, 2732], [2048, 1536], [1668, 2224], [1536, 2048], [1294, 750], [1242, 2148], [1200, 627], [1136, 640], [1125, 2436], [1024, 1024]];
const SIZES_APP_ICON = [64, 167, 192, 512];
const ASSETS_APP_ICON = [{
  favico: {
    width: 512,
    height: 512,
    path: 'img/favicon.ico'
  }
}];
const AssetFlagData = FLAG_CODES.map(flagCode => {
  const data = _objectSpread(_objectSpread({}, FLAG_SIZE), {}, {
    path: "".concat(FLAG_PATH_PREFIX).concat(flagCode.toLowerCase(), ".png")
  });

  return {
    [flagCode]: data
  };
}).reduce((current, next) => _objectSpread(_objectSpread({}, current), next), {});
const AssetAppIcons = [...SIZES_APP_ICON.map(iconSize => {
  const data = {
    width: iconSize,
    height: iconSize,
    path: "img/AppIcon".concat(iconSize, ".png")
  };
  return {
    [iconSize]: data
  };
}), ...ASSETS_APP_ICON].reduce((current, next) => _objectSpread(_objectSpread({}, current), next), {});
const AssetSplashIcons = SIZES_SPLASH_SCREEN.map(splashSize => {
  const [width, height] = splashSize;

  if (width === undefined || height === undefined) {
    throw new Error("Invalid splash screen sizing. Found width:".concat(width !== null && width !== void 0 ? width : 'undefined', ", height:").concat(height !== null && height !== void 0 ? height : 'undefined'));
  }

  const data = {
    width,
    height,
    path: "img/Splash".concat(width, "x").concat(height, ".png")
  };
  return {
    ["".concat(width, "x").concat(height)]: data
  };
}).reduce((current, next) => _objectSpread(_objectSpread({}, current), next), {});
export default Object.freeze({
  Flag: AssetFlagData,
  AppIcon: AssetAppIcons,
  Splash: AssetSplashIcons,
  Misc: {
    Alpha: {
      width: 1,
      height: 1,
      path: 'img/Misc/alpha.png'
    },
    Alpha_Debug: {
      width: 200,
      height: 200,
      path: 'img/Misc/alpha_debug.png'
    }
  }
});